export var ReportingPrefetchStage = /*#__PURE__*/ function(ReportingPrefetchStage) {
    ReportingPrefetchStage["NotApplicable"] = "N/A";
    /// The video provider has given a playback response
    ReportingPrefetchStage["VideoProviderComplete"] = "VIDEO_PROVIDER_COMPLETE";
    /// Freewheel call has finished but no ads have been requested yet
    ReportingPrefetchStage["VamComplete"] = "VAM_COMPLETE";
    /// We have either set up the SSAI session or received the CSAI ads
    ReportingPrefetchStage["AdInitComplete"] = "AD_INIT_COMPLETE";
    /// The player is fully loaded and waiting in a paused state
    ReportingPrefetchStage["EngineIdle"] = "ENGINE_IDLE";
    return ReportingPrefetchStage;
}({});
export var Source = /*#__PURE__*/ function(Source) {
    Source["OTT"] = "OTT";
    Source["STB"] = "STB";
    return Source;
}({});

//# sourceMappingURL=conviva-addon-proposition.enums.js.map